module.exports = __webpack_public_path__ + "static/img/empty.5ba82c19.webp";